let invitationSecret: string | null = null;

/**
 * Extract the bearer credential before React, API clients, analytics, or the
 * service worker start. It remains in module memory only and is never exposed
 * through browser persistence or a request URL.
 */
export function scrubInvitationSecretFromLocation(
	location: Location = window.location,
	history: History = window.history,
) {
	if (location.pathname !== "/invite" || !location.hash) return null;
	const params = new URLSearchParams(location.hash.slice(1));
	const candidate = params.get("token");
	history.replaceState(history.state, "", `${location.pathname}${location.search}`);
	if (!candidate || !/^[A-Za-z0-9_-]{43}$/.test(candidate)) return null;
	invitationSecret = candidate;
	return candidate;
}

export function hasInvitationSecret() {
	return invitationSecret !== null;
}

/** Builds the only permitted invitation transport: a JSON request body. */
export function invitationSecretBody(fields: Record<string, unknown> = {}) {
	if (!invitationSecret) throw new Error("Invitation is unavailable");
	return JSON.stringify({ token: invitationSecret, ...fields });
}

export function clearInvitationSecret() {
	invitationSecret = null;
}

if (typeof window !== "undefined") scrubInvitationSecretFromLocation();
